import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';

import { connect } from 'react-redux';
import { UiActions } from 'state/actions/UiActions';

import { PrimaryPinkButton } from 'components/buttons/PrimaryPinkButton';

import styles from './styles.module.scss';

export class GlamstarChallenge5 extends Component {
  constructor(props) {
    super(props);
    const { match, location } = this.props;
    this.campaignId = match.params?.id;
    this.canAccess = location.state?.canAccess;

    this.state = {
      videos: [],
      challenge: null,
    };
  }

  currentDateIsAfterDateTo = dateTo => {
    return dayjs().isAfter(dateTo, 'days');
  };

  getCampaign = async () => {
    this.props.loaderShow();
    await ExecuteRequest(
      GlamboxEndpoints.Campaign.getByIdWithoutDetail,
      null,
      'GET',
      { Authorization: this.props.token },
      {
        campaignId: this.campaignId,
      },
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            challenge: result,
            videos: [
              {
                title: 'VÍDEO TESTE 1',
                url: '	https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21706.mp4',
              },
              {
                title: 'VÍDEO TESTE 2',
                url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21707.mp4',
              },
              {
                title: 'VÍDEO TESTE 3',
                url: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21708.mp4',
              },
            ],
          });
        } else {
          this.props.publishErrorAlert('Houve um erro ao carregar os desafio');
        }
        this.props.loaderHide();
      }
    );
  };

  componentDidMount() {
    const { history } = this.props;

    if (!this.canAccess) {
      history.push('/glampartner/glamstar/desafios');
      return;
    }

    this.getCampaign();
  }

  render() {
    const { videos, challenge } = this.state;

    if (!challenge) {
      return null;
    }

    const challengeClosed = this.currentDateIsAfterDateTo(challenge.dateTo);

    let currentChallenge = {
      ...challenge,
      dateFrom: new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
      }).format(new Date(challenge.dateFrom)),
      dateTo: new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
      }).format(new Date(challenge.dateTo)),
    };

    return (
      <div className={styles.container}>
        <header className={styles.concurseHeader}>
          <h1 className={styles.concurseTitle}>{currentChallenge.title}</h1>
          <span className={styles.concurseTime}>
            Prazo: <time>{currentChallenge.dateFrom}</time> até{' '}
            <time>{currentChallenge.dateTo}</time>
          </span>
        </header>

        <main className={styles.hero}>
          <div className={styles.challengeWrapper}>
            <video className={styles.currentChallengeVideo} controls>
              <source
                src="https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21709.mp4"
                type="video/mp4"
              />
            </video>
          </div>

          <section className={styles.yourMission}>
            <h2 className={styles.yourMissionTitle}>Sua missão</h2>
            <p className={styles.paragraph}>
              <p>
                No challenge <strong>Feito pra mim!</strong> você deve preencher o
                seu perfil de beleza e mostrar que como é rápida e prazerosa sua
                escolha de produtos ativando o filtro “Meu perfil”, exclusivo,
                da Loja da Glambox.
                <br />
                Não esqueça de destacar todos os benefícios da Loja e mostrar como
                é fácil realizar uma compra quando você recebe as sugestões de
                produtos de acordo com o seu perfil de beleza.
              </p>
            </p>
          </section>

          <section className={styles.rules}>
            <h2 className={styles.rulesTitle}>Regras</h2>
            <div className={styles.rulesContent}>
              <ol className={styles.rulesList}>
                <li>
                Preencher seu perfil de beleza na Loja da Glambox, ativar o filtro
                <strong>Meu Perfil</strong> e mostrar como o Glam Match encontra os produtos que
                mais combinam com você
                </li>
                <li>
                  Divulgar e enaltecer pelo menos um produto que você recebeu da Glam Beauty 
                </li>
                <li>
                  Ter no máximo 1 minuto
                </li>
                <li>
                  Na legenda, marcar a @useglambeauty e a @glamboxbrasil, além de usar as
                  hashtags #Glamstar2022 #glamstarfeitopramim
                </li>
              </ol>
              <br />

              <p className={styles.rulesDescription}>
                Você é livre para criar o seu conteúdo com o roteiro e formato que você desejar:
                vertical ou horizontal, pensado como trends ou talks e com foco na rede social que 
                você preferir, desde que responda a todos os objetivos.Queremos ver a sua 
                criatividade em ação! 
              </p>

              <strong className={styles.rulesInfo}>Tempo e formato</strong>
              <p className={styles.rulesDescription}>
                Você pode subir o vídeo do challenge em qualquer canal entre Tiktok, Instagram e
                Youtube! Mas olha só: o vídeo só pode ter até um minuto!
              </p>
              <strong className={styles.rulesInfo}>Prazo de envio</strong>
              <p className={styles.rulesDescription}>
                <p>
                  Poste o seu vídeo nas redes sociais entre os dias 18/05/2022 e 24/05/2022, mas
                  lembrem-se que quanto antes você postar, mais tempo terá de bombar seu número de 
                  visualizações até a data da avaliação! 
                </p>
                <p>  
                  Seus links e seu vídeo favorito devem ser enviados até o dia 24/05/2022. 
                </p>
              </p>

              <ol className={styles.rulesListDisc}>
                <strong className={styles.rulesInfo}>
                  Critérios de avaliação
                </strong>
                <li>
                  A sua capacidade de cumprir de maneira clara os objetivos desse vídeo 
                </li>
                <li>
                  Sua criatividade e qualidade técnica de seu vídeo 
                </li>
                <li>
                  A quantidade de views somados de todas as plataformas em que você postar o vídeo
                </li>
                <li>
                  O respeito de todas as regras do challenge
                </li>
              </ol>
            </div>
          </section>

          <Link
            className={styles.sendChallenge}
            to={{
              pathname: `/glampartner/glamstar/desafio/form/${this.campaignId}`,
              state: { canAccess: this.canAccess },
            }}
          >
            <PrimaryPinkButton disabled={challengeClosed}>
              Enviar Challenge
            </PrimaryPinkButton>
          </Link>

          <section className={styles.challengesExample}>
            <h2 className={styles.challengeExampleTitle}>Vídeos de exemplo</h2>
            <p className={styles.paragraph}>
              Nosso time preparou alguns exemplos de vídeos para te ajudar a se soltar! Capriche muito na sua produção.
            </p>
            <div className={styles.videosExample}>
              {videos?.length > 0 &&
                videos.map(video => (
                  <video key={video.title} controls>
                    <source src={video.url} type="video/mp4"></source>
                  </video>
                ))}
            </div>
          </section>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
});

const mapDispatchToProps = dispatch => ({
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
});

GlamstarChallenge5 = connect(
  mapStateToProps,
  mapDispatchToProps
)(GlamstarChallenge5);
